<template>
  <div :class="gridClass">
    <div
      v-for="(stat, index) in stats"
      :key="index"
      class="stat-card group animate-fade-up bg-white dark:bg-surface-900/60 border-surface-200/80 dark:border-surface-800/60"
      :style="{ animationDelay: `${index * 0.06}s`, animationFillMode: 'backwards' }"
    >
      <!-- Accent left border -->
      <div
        class="absolute top-3 bottom-3 left-0 w-1 rounded-r-full transition-all duration-300 group-hover:top-2 group-hover:bottom-2"
        :style="{ backgroundColor: stat.color || '#10B981' }"
      ></div>

      <div class="flex items-center justify-between pl-1">
        <div class="flex-1 min-w-0">
          <p class="text-xs font-semibold text-surface-400 dark:text-surface-500 uppercase tracking-wider mb-1.5">
            {{ stat.label }}
          </p>
          <p class="text-lg sm:text-xl lg:text-2xl font-extrabold text-surface-900 dark:text-surface-50 font-mono leading-tight break-words">
            {{ stat.value }}
          </p>
          <p v-if="stat.subtext" class="text-xs text-surface-400 dark:text-surface-600 mt-1.5">
            {{ stat.subtext }}
          </p>
        </div>
        <div
          v-if="stat.icon"
          class="ml-3 flex-shrink-0 p-2 rounded-xl transition-all duration-300 group-hover:scale-110"
          :style="{ backgroundColor: `${stat.color || '#10B981'}12` }"
        >
          <component
            :is="stat.icon"
            class="h-4 w-4 lg:h-5 lg:w-5"
            :style="{ color: stat.color || '#10B981' }"
          />
        </div>
      </div>

      <div v-if="stat.change" class="mt-3 flex items-center text-xs pl-1">
        <ArrowTrendingUpIcon
          v-if="stat.change > 0"
          class="h-3.5 w-3.5 text-accent-500 mr-1"
        />
        <ArrowTrendingDownIcon
          v-else
          class="h-3.5 w-3.5 text-red-500 mr-1"
        />
        <span :class="stat.change > 0 ? 'text-accent-600 dark:text-accent-400 font-semibold' : 'text-red-600 dark:text-red-400 font-semibold'">
          {{ Math.abs(stat.change) }}%
        </span>
        <span class="text-surface-400 dark:text-surface-600 ml-1">vs last period</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { ArrowTrendingUpIcon, ArrowTrendingDownIcon } from '@heroicons/vue/24/outline'

const props = defineProps({
  stats: {
    type: Array,
    required: true,
    validator: (stats) => {
      return stats.every(stat =>
        stat.label && (stat.value !== undefined)
      )
    }
  }
})

const gridClass = computed(() => {
  const count = props.stats.length
  if (count >= 5) return 'grid grid-cols-2 md:grid-cols-5 gap-4'
  if (count === 4) return 'grid grid-cols-2 md:grid-cols-4 gap-4'
  if (count === 3) return 'grid grid-cols-1 md:grid-cols-3 gap-4'
  return 'grid grid-cols-1 md:grid-cols-2 gap-4'
})
</script>
